module.exports = __webpack_public_path__ + "static/media/JaydenPangEdited.a03dfd72.jpg";